import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { QuickLoanService } from "../services/quickLoan.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
declare var $: any;
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";
@Component({
  selector: "app-quickloan-sending-receiving-report",
  templateUrl: "./quickloan-sending-receiving-report.component.html",
  styleUrls: ["./quickloan-sending-receiving-report.component.scss"],
})
export class QuickloanSendingReceivingReportComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;
  SelectStatus: any = "All";
  dataSource: any;
  displayedSendingReceivingColumns: string[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private _QuickLoanService: QuickLoanService,
    
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Sending/Receiving Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }
 
searchSendingReceivingReport() {
  this.showSpinner = true;
  this.displayedSendingReceivingColumns = [
    "Id",
    "Application_No",
    "LoanAc_No",
    "Customer_Name",
    "Branch_Name",
    "Product_Name",
    "Loan_Amount",
    "Detail",
    "Courier_By",
    "File_SendBy",
    "File_sendOn",
    "Sending_Remark",
    "File_ReceiveBy",
    "File_ReceiveOn",
    "Receive_Remarks",
    "File_Status",
  ];

  this._QuickLoanService.Quickloan_FileSending_And_Receving_Report({ FileStatus: this.SelectStatus }).subscribe(
    (response: any) => {
      if (response && response.length > 0) {
        response.forEach((row, idx) => row.Id = idx + 1);
        this.dataSource = new MatTableDataSource(response);
        setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          });
      } else {
        this.dataSource = null;
      }
      this.showSpinner = false;
    },
    (error: any) => {
      this.showSpinner = false;
      this.snackBar.open('Error fetching report', 'Close', { duration: 3000 });
    }
  );
}
onSelectStatusChange(event: any) {
    this.dataSource ="";
}

 exportTable(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "fileSendingReceivingReportTablePrint"
    ) as HTMLTableElement;
    const worksheetName = "File Sending Receiving Report";
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
